import React, { useState, useEffect } from 'react';
import { fetchData } from '../common/Api';
import TableRowsIcon from '@mui/icons-material/TableRows';
import CommonTable from '../common/CommonTable';
import AppsIcon from '@mui/icons-material/Apps';
import ItemList from '../common/ItemList';
import { teamColumns } from '../common/TableColumns';
import { useHistory } from 'react-router-dom';
import { useSpace } from '../common/SpaceContextProvider';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import InfoIcon from '@mui/icons-material/Info';
import CsvDownloadButton from '../common/CsvDownloadButton';


const TeamsTab = ({ id }) => {

    const { setTeams } = useSpace();
    const history = useHistory();
    const [data, setData ] = useState([]);
    const [error, setError] = useState(null);
    const [showAsList, setShowAsList] = useState(true);

    const tooltip = (
    <Tooltip id="teams-tab-tooltip">
        Create teams either by manually adding them one by one manually 
        or by importing them from a CSV file.
    </Tooltip>
    );    

    const getData = async () => {
        try {
            await fetchData(
            `/api/v1/spaces/${id}/teams`
            ).then(response => setData(response.data))
        } catch (error) {
            setError(error);
        }
    }

    useEffect(() => {
        const getTeamsData = async () => {
            try {
                await fetchData(
                `/api/v1/spaces/${id}/teams`
                ).then(response => setData(response.data))
            } catch (error) {
                setError(error);
            }
        }
        getTeamsData();
    }, [id]);

    useEffect(() => {
        setTeams(data);
    }, [data]);

    useEffect(()=> {
        if (error) {
            alert(`Error loading teams :: ${error.message}`);
            if (error.status === 401){
                history.push('/login');
            }
            setError(null);
        }
    }, [error]);

    return (
        <div className='tab-container'>
            <div className='tab-container-main-panel'>
            { 
            showAsList ? 
                <ItemList 
                    data={data} 
                    cols={teamColumns} 
                    baseUrl={`/api/v1/spaces/${id}/teams`} 
                    setData={getData}
                    fields={['name', 'description', 'members']}
                    disableClick={true}
                    testDataFname={'/teams.json'}
                /> : 
                <CommonTable data={data} cols={teamColumns}/> 
            }
            </div>
            <div className='switch-list-table-view-container'>
            <OverlayTrigger placement="bottom" overlay={tooltip}>
                <div className='icon-container'><InfoIcon className='switch-view'></InfoIcon></div>
            </OverlayTrigger>
            <div className='icon-container'><TableRowsIcon 
                className={`switch-view ${showAsList ? 'selected' : null}`} 
                onClick={() => setShowAsList(true)}/>
            </div>
            <div className='icon-container'><AppsIcon 
                className={`switch-view ${!showAsList ? 'selected' : null}`} 
                onClick={() => setShowAsList(false)}/>
            </div>
            {data.length > 0 && <CsvDownloadButton data={data} filename='teams.csv'/>}
            </div>
        </div>
    )
}

export default TeamsTab;